import siteConfig from "../../config/siteConfig";
import socialRing from "../../assets/imgs/ui/decorations/gem-frame.png";
import "./SiteFooter.scss";

const SiteFooter = () => {
  return (
    <footer className="mu-footer">
      <div className="mu-footer__inner">
        <div className="mu-footer__social">
          <span>FOLLOW US</span>
          <a href={siteConfig.social.facebook} target="_blank" rel="noreferrer">
            <img src={socialRing} alt="" />
            <span>FB</span>
          </a>
          <a
            href={siteConfig.social.discordInvite}
            target="_blank"
            rel="noreferrer"
          >
            <img src={socialRing} alt="" />
            <span>DC</span>
          </a>
          <a href={siteConfig.social.youtube} target="_blank" rel="noreferrer">
            <img src={socialRing} alt="" />
            <span>YT</span>
          </a>
        </div>
        <div className="mu-footer__copy">
          © {new Date().getFullYear()} Mu Beginning. All rights reserved.
        </div>
        <div className="mu-footer__links">
          <a href={siteConfig.social.discordInvite}>TERMS OF SERVICE</a>
          <span>|</span>
          <a href={siteConfig.social.discordInvite}>PRIVACY POLICY</a>
          <span>|</span>
          <a href={siteConfig.social.discordInvite}>CONTACT US</a>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
